
import { IUser, UserRole } from "../_types/user";
import { IObjectPolicy, IPolicy, IPolicyDefinition, IPolicyObject, IPolicyQuery_DTO, IPolicyRequest, PolicyObjectCN, PolicyObjectTypeOptions } from "../_types/ewpolicy";
import { IFetchData } from "../_types/post";
import { APIPost } from "./http";



/*
This is a convention.  One could argue that this violates open/close principle,
but I would argue that your not adding new policies without understanding where
and how to evaluate that policy.  So, and addition to this structure would necessarily
include a full stack change.
*/
export class PolicyOptions {
    static readonly USER_ISTESTUSER = "policy.member.istester";
  
    static readonly LOCATION_USESOMNIX = "policy.servicelocation.uses_omnix"

    static readonly User_Account_Manager_Attendant_Report = "policy.user.account_manager_attendant_report";
    static readonly User_Add_Groupon_Codes = "policy.user.add_groupon_codes";
    static readonly User_Add_Usage = "policy.user.add_usage";
    static readonly User_Add_Use_codes = "policy.user.add_use_codes";
    static readonly User_Adjust_Payout_Split = "policy.user.adjust_payout_split";
    static readonly User_Ban_User = "policy.user.ban_user";
    static readonly User_Can_See_PPI = "policy.user.canseeppi";
    static readonly User_Can_Change_Email = "policy.user.change_email";
    static readonly User_Can_Change_Password = "policy.user.change_password";
    static readonly User_Custom_Email_Campaign = "policy.user.custom_email_campaign";
    static readonly User_Edit_Car_Details = "policy.user.edit_car_details";
    static readonly User_Email = "policy.user.email";
    static readonly User_IndestructibeInvite = "policy.user.indestructibleinvite";
    static readonly User_IsTester = "policy.user.istester";
    static readonly User_Manage_Account_Managers = "policy.user.manage_account_managers";
    static readonly User_Manage_Locations = "policy.user.manage_locations";
    static readonly User_Manage_Permissions = "policy.user.manage_permissions";
    static readonly User_Manage_PromoCodes = "policy.user.manage_promocodes";
    static readonly User_Manage_Users = "policy.user.manage_users";
    static readonly User_Member_Notes = "policy.user.member_notes";
    static readonly User_Show_Annual_Rev_Not_Growth = "policy.user.show_annual_rev_not_growth";
    static readonly User_Start_Remote_Start = "policy.user.start_remote_start";
    static readonly User_Steet_Team = "policy.user.street_team";
    static readonly User_View_Attendant_Report = "policy.user.view_attendant_report";
    static readonly User_View_Leads = "policy.user.view_leads";
    static readonly User_View_Locations_Report = "policy.user.view_locations_report";
    static readonly User_View_Payout_Report = "policy.user.view_payout_report";
    static readonly User_View_Sales_People = "policy.user.view_sales_people";
  } 


  /**
 * Policies are stored with the object, but lazy loaded.  This function will either pull
 * the policy from memory, or go out to the serve to get and store the policy.
 * @param object any object of type IUser for which you want the permission
 * @param policy the permission you want
 * @param autoSet indicates if this method should updat the permission object in memory (** this may have side-effects if useEffect tracking)
 */
export const GetPermissionsLazyLoad = async (policyObject: IUser, policy: IPolicyRequest[]): Promise<IPolicy[]> => {

    let toReturn: IPolicy[] = [];


    return toReturn;

}

/**
 * Policies are stored with the object, but lazy loaded.  This function will either pull
 * the policy from memory, or go out to the serve to get and store the policy.
 * @param object any object of type IUser for which you want the permission
 * @param policy the permission you want
 * @param autoSet indicates if this method should updat the permission object in memory (** this may have side-effects if useEffect tracking)
 */
export const GetPermissionLazyLoad = async (policyObject: IUser, policy: IPolicyRequest): Promise<IPolicy> => {

    let toReturn: IPolicy = { policy_cn: PolicyOptions.USER_ISTESTUSER, value: "0", term: "yn" };
    /*
    Object Type Mapping
        if objecttype = 1 (user)
            if role = 1, then member
            if role = 2, then attendant
            if role = 3,4,5,6, then user
        if objecttype = 2 (servicelocation)
            then servicelocation
    */


    let object_type_cn: string = PolicyObjectCN(policyObject.objectType);
    

    const compareContext = (search: string | undefined, match: string|undefined):boolean => {

        
        let searchString = (search) ? search : "";
        let matchString = (match) ? match : "";

        return searchString === matchString;       
        
    }; 
    

    let match: IPolicy | undefined = (policyObject.policies)
    ? policyObject.policies?.find(e => e.policy_cn === policy.policy_cn && e.term === policy.term && compareContext(e.context, policy.context) )
    : { 
        policy_cn: policy.policy_cn,
        term: policy.term,
        context: policy.context,
        value: null //important... if the policy is found with null value, the caller should do whatever is most restrictive
    };


    //if not in memory, we need to go out and get it
    if (match === undefined) {

        match = await GetPolicy((policyObject as IPolicyObject), object_type_cn, policy);

        if (!policyObject.policies) {
            policyObject.policies = [];
        }
        policyObject.policies!.push(match);
        
        toReturn = match;


    } 


    //return Promise.resolve(toReturn);
    return toReturn;


};

export const GetPolicyDefinitions = async (object_type_cn: string): Promise<IPolicyDefinition[]> => {



    let post: IFetchData = {
        authorize: true,
        method: "GET",
        refresh: false,
        service: "policy",
        relay_to: `/bridge/listpolicies/${object_type_cn}`
    };

    let toReturn: IPolicyDefinition[] = [];
    let result = await APIPost<IPolicyDefinition[]>(post);
    if (result != null) {
        toReturn = result;
    }

    
    return toReturn;


}

export const ExpirePolicy = async (id: number): Promise<IObjectPolicy | null> => {



    let post: IFetchData = {
        authorize: true,
        method: "GET",
        refresh: false,
        service: "policy",
        relay_to: `/bridge/expirepolicy/${id}`
    };

    let toReturn: IObjectPolicy | null = null;
    let result = await APIPost<IObjectPolicy>(post);

    if (result != null) {
        toReturn = result;
    }

    
    return toReturn;


}

export const GetObjectPolicies = async (object_id: number, object_type_cn: string): Promise<IObjectPolicy[]> => {

    let toPost = { object_id: object_id, object_type_cn: object_type_cn };
    let toReturn: IObjectPolicy[] = [];


    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "policy",
        relay_to: "/bridge/getpolicies",
        ...toPost
    };

    let result = await APIPost<IObjectPolicy[]>(post);

    if (result) {
        toReturn = result;
    }



    return toReturn;


}

export const ClonePolicy = (policy: IObjectPolicy): IObjectPolicy => {
    let toReturn:IObjectPolicy = {...policy};
    toReturn.terms = [];
    policy.terms.forEach(e => {
        toReturn.terms.push({...e});
    })
    return toReturn;
}

export const GetGroupPolicyObjects = () => {
    let toReturn: IPolicyObject[] = [
        { objectType: PolicyObjectTypeOptions.account_manager, displayName:"Account Manager", id: 0},
        { objectType: PolicyObjectTypeOptions.admin, displayName:"Administrator", id: 0},
        { objectType: PolicyObjectTypeOptions.attendant, displayName:"Attendant", id: 0},
        { objectType: PolicyObjectTypeOptions.member, displayName:"Member", id: 0},
        { objectType: PolicyObjectTypeOptions.salesperson, displayName:"Sales Person", id: 0},
        { objectType: PolicyObjectTypeOptions.owner, displayName:"Owner", id: 0},
        { objectType: PolicyObjectTypeOptions.support, displayName:"Support", id: 0},
        { objectType: PolicyObjectTypeOptions.root, displayName:"Default", id: 0},
    ];

    return toReturn;
}

export const CreatePolicy = async (policyObject: IPolicyObject, policy: IObjectPolicy): Promise<IObjectPolicy> => {

    let toPost: IObjectPolicy = ClonePolicy(policy);
    toPost.id = 0;
    toPost.object_id = policyObject.id!;
    toPost.object_type_cn = PolicyObjectCN(policyObject.objectType);


    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "policy",
        relay_to: "/bridge/createpolicy",
        ...toPost
    };

    let result: IObjectPolicy | null = await APIPost<IObjectPolicy>(post);
    if (result !== null) {
        toPost = result;
    }
    

    return toPost;


}

const GetPolicy = async (policyObject: IPolicyObject, object_type_cn: string, policy: IPolicyRequest): Promise<IPolicy> => {

    let toPost: IPolicyQuery_DTO = {
        object_id: policyObject.id!,
        object_type_cn: object_type_cn,
        param_cn: policy.term,
        policy_cn: policy.policy_cn,
        context: (policy.context) ? policy.context : "",
        when: policy.when

    };


    let post: IFetchData = {
        authorize: true,
        method: "POST",
        refresh: false,
        service: "policy",
        relay_to: "/bridge/getpolicyterm",
        ...toPost
    };

    let result = await APIPost<string>(post);

    let value = "";
    if (result !== null && result !== undefined) {
        value = result;
    }


    let toReturn: IPolicy = {
        policy_cn: policy.policy_cn,
        term: policy.term,
        value: value.toString(),
        context: policy.context
    };

    return toReturn;


}

